module.exports = __webpack_public_path__ + "static/media/file_green.83fc52c8.svg";